import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Estados, IMensaje } from 'modelosSeguridad/src';
import { MaterialModule } from '../../../../auxiliares/material.module';
import { UploadFileComponent } from '../../../../auxiliares/upload-file/upload-file.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { IntegracionesService } from '../../../../auxiliares/servicios/http/integraciones.service';
import { CardHeaderComponent } from '../../../../componentes/card-header/card-header.component';
import { ContentCardComponent } from '../../../../componentes/content-card/content-card.component';

interface DialogData {
  estadosDisponibles: Estados[];
  mostrarCamposVecino: boolean;
  verSucesos: boolean;
  categorias: string[];
  tags: string[];
}

export interface AgregarEstadoDialogResult {
  estado: Estados;
  notaPredefinida?: string;
  nota?: string;
  notaInterna?: string;
  causante?: string;
  categoriasDeEvento?: string;
  tagsDeEvento?: string[];
  urls?: string[];
}

@Component({
  selector: 'app-agregar-estado-dialog',
  templateUrl: './agregar-estado-dialog.component.html',
  styleUrl: './agregar-estado-dialog.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    UploadFileComponent,
    NgSelectModule,
    CardHeaderComponent,
    ContentCardComponent,
  ],
})
export class AgregarEstadoDialogComponent implements OnInit {
  data = inject<DialogData>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<
      MatDialogRef<
        AgregarEstadoDialogComponent,
        AgregarEstadoDialogResult | null
      >
    >(MatDialogRef);
  private service = inject(IntegracionesService);

  public form = new FormGroup({
    estado: new FormControl<Estados | null>(null, Validators.required),
    notaPredefinida: new FormControl<string | null>(null),
    nota: new FormControl<string | null>(null),
    notaInterna: new FormControl<string | null>(null),
    causante: new FormControl<string | null>(null),
    categoriasDeEvento: new FormControl<string | null>(null),
    tagsDeEvento: new FormControl<string[] | null>(null),
  });

  get esEstadoFinalizada(): boolean {
    return this.form.get('estado')?.value === 'Finalizada';
  }

  public urls: string[] = [];
  public loadingFile = false;
  public mensajes: IMensaje[] = [];

  async ngOnInit(): Promise<void> {
    if (this.data.mostrarCamposVecino) {
      try {
        const res = await this.service.getMensajesPredefinidos({
          sort: 'texto',
        });
        this.mensajes = res?.datos || [];
      } catch {
        this.mensajes = [];
      }
    }
  }

  public onUrlsChange(urls: string[]): void {
    this.urls = urls;
  }

  public eliminarImagen(index: number): void {
    this.urls.splice(index, 1);
  }

  public confirmar(): void {
    if (this.form.invalid || this.loadingFile) return;
    this.dialogRef.close({
      estado: this.form.value.estado as Estados,
      notaPredefinida: this.form.value.notaPredefinida || undefined,
      nota: this.form.value.nota || undefined,
      notaInterna: this.form.value.notaInterna || undefined,
      causante: this.form.value.causante || undefined,
      categoriasDeEvento: this.form.value.categoriasDeEvento || undefined,
      tagsDeEvento: this.form.value.tagsDeEvento?.length
        ? this.form.value.tagsDeEvento
        : undefined,
      urls: this.urls.length ? [...this.urls] : undefined,
    });
  }

  public cancelar(): void {
    this.dialogRef.close(null);
  }
}
